

import * as client from '../../services/client';
import { TYPES } from '../../common/constants';
import { toast } from 'react-toastify';
import { store } from '..';

const fetchInboxListDone = (payload) => dispatch => {
    dispatch({
        type: TYPES.FETCH_INBOX_LIST_DONE,
        payload: payload
    })
}
const fetchInboxAnnouncementsListDone = (payload) => dispatch => {
    dispatch({
        type: TYPES.FETCH_INBOX_ANNOUNCEMENTS_LIST_DONE,
        payload: payload
    })
}
const fetchChatMessagesDone = (payload) => dispatch => {
    dispatch({
        type: TYPES.FETCH_CHAT_MESSAGES_DONE,
        payload: payload
    })
}
const fetchChatUserInformationDone = (payload) => dispatch => {
    dispatch({
        type: TYPES.FETCH_CHAT_USER_INFORMATION_DONE,
        payload: payload
    })
}
const fetchInboxAnnouncementsByPropertyDone = (payload) => dispatch => {
    dispatch({
        type: TYPES.FETCH_INBOX_ANNOUNCEMENTS_DONE,
        payload: payload
    })
}
const fetchInboxSuitesListDone = (payload) => dispatch => {
    dispatch({
        type: TYPES.FETCH_INBOX_SUITES_LIST_DONE,
        payload: payload
    })
}
const fetchInboxServiceRequestListDone = (payload) => dispatch => {
    dispatch({
        type: TYPES.FETCH_INBOX_SERVICE_REQUESTS_LIST_DONE,
        payload: payload
    })
}
export const startInboxLoader = () => dispatch => {
    dispatch({
        type: TYPES.START_INBOX_LOADER,
        payload: true
    })
}
export const stopInboxLoader = () => dispatch => {
    dispatch({
        type: TYPES.STOP_INBOX_LOADER,
        payload: false
    })
}
export const onSaveMessageInLocalList = (payload) => dispatch => {
    dispatch({
        type: TYPES.SAVE_MESSAGE_IN_LOCAL_LIST,
        payload: payload
    })
}
const onSaveSendMessageToChatList = (payload) => dispatch => {
    dispatch({
        type: TYPES.SAVE_SEND_MESSAGE_TO_CHAT_LIST,
        payload: payload
    })
}
export const saveInboxPaginationCount = (payload) => ({
    type: TYPES.INBOX_SERVICE_REQUEST_PAGINATION,
    payload,
});
export const saveInboxPageCount = (payload) => ({
    type: TYPES.INBOX_SERVICE_REQUEST_PAGE_COUNT,
    payload,
});
export const clearInboxPaginationCount = () => ({
    type: TYPES.CLEAR_INBOX_PAGINATION_COUNT
});
export const onClearInboxServiceRequestsList = () => ({
    type: TYPES.CLEAR_INBOX_SERVICE_REQUESTS
});  
export const fetchInboxList = (userId, roleName, search, loader, type) => dispatch => {
    if(loader) {
        dispatch(startInboxLoader())
    }
    return client.fetchInboxList(userId, roleName, search).then(response => {                
        if(response.status === 200) {
            response.json().then(responseJson => {
               dispatch(fetchInboxListDone(responseJson))
                if(type === "initial") {                    
                const redirectionUrl = window.location.href;
                const splitValue = redirectionUrl.split('app/inbox/')[1];
                if(splitValue) {
                    const updatedUrl = redirectionUrl.substring(0, redirectionUrl.lastIndexOf('/'));
                    window.history.pushState(null, null, updatedUrl);

                    const selectedItem = responseJson?.filter(item => item.referenceId === splitValue)[0];
                        if(selectedItem && selectedItem.referenceId) {
                            dispatch(onSaveSelectedItem(selectedItem))
                            dispatch(fetchChatMessages(selectedItem.referenceId, selectedItem.referenceType))
                            dispatch(onFetchChatUserInformation(selectedItem.referenceId, selectedItem.referenceType))
                            dispatch(onUpdateUnreadToReadMessages(selectedItem.referenceId, selectedItem.referenceType, userId));
                        }
                    }
                }
            })
        } else {
            toast.error(` 🚫 Something went wrong with fetching messages, please try again.`, { autoClose: 3000, position: 'top-center' })
            dispatch(fetchInboxListDone([]))
        }
    }).catch(() => {
        toast.error(` 🚫 Something went wrong with fetching messages, please try again.`, { autoClose: 3000, position: 'top-center' })
        dispatch(fetchInboxListDone([]))
    })
}

export const fetchAnnouncementList = (userId, roleName, search, loader) => dispatch => {
    if(loader) {
        dispatch(startInboxLoader())
    }
    return client.fetchAnnouncementList(userId, roleName, search).then(response => {                
        if(response.status === 200) {
            response.json().then(responseJson => {
                if(responseJson.statusCode === 200) {
                    dispatch(fetchInboxAnnouncementsListDone(responseJson.data))
                } else {
                    toast.error(` 🚫 Something went wrong with fetching announcements, please try again.`, { autoClose: 3000, position: 'top-center' })
                    dispatch(fetchInboxAnnouncementsListDone([]))
                }
            })
        } else {
            dispatch(fetchInboxAnnouncementsListDone([]))
            toast.error(` 🚫 Something went wrong with fetching announcements, please try again.`, { autoClose: 3000, position: 'top-center' })
        }
    }).catch(() => {
        dispatch(fetchInboxAnnouncementsListDone([]))
        toast.error(` 🚫 Something went wrong with fetching announcements, please try again.`, { autoClose: 3000, position: 'top-center' })
    })
}
export const onFetchInboxSuitesList = (userId, roleName, search, loader) => dispatch => {
    if(loader) {
        dispatch(startInboxLoader())
    }
    return client.fetchInboxSuitesList(userId, roleName, search).then(response => {                
        if(response.status === 200) {
            response.json().then(responseJson => {
                dispatch(fetchInboxSuitesListDone(responseJson))
            })
        } else {
            dispatch(fetchInboxSuitesListDone([]))
        }
    }).catch(() => {
        toast.error('🚫 Something went wrong with fetching suites, Please try again.',{autoClose:3000,position:'top-center'})
        dispatch(fetchInboxSuitesListDone([]))
    })
}
export const onFetchInboxServiceRequestList = (userId, roleName, count, search, loader) => dispatch => {
    if(count === 1) {
        dispatch(clearInboxPaginationCount());
        if(loader) {
           dispatch(startInboxLoader())
        }
    }
    return client.fetchInboxServiceRequestList(userId, roleName, count, search).then(response => {                
        if(response.status === 200) {
            response.json().then(responseJson => {
               dispatch(fetchInboxServiceRequestListDone(responseJson.serviceRequestsList.results))
               dispatch(saveInboxPaginationCount(count));
               dispatch(saveInboxPageCount(responseJson.serviceRequestsList.pageCount));
            })
        } else {
            dispatch(fetchInboxServiceRequestListDone([]))
        }
    }).catch(() => {
        toast.error('🚫 Something went wrong with fetching service requests, Please try again.',{autoClose:3000,position:'top-center'})
        dispatch(fetchInboxServiceRequestListDone([]))
    })
}
export const fetchChatMessages = (referenceId, referenceType, loader) => dispatch => {
    if(loader === false) {
    } else {
        dispatch(startInboxLoader())
    }
    return client.fetchChatMessages(referenceId, referenceType).then(response => {
        if(response.status === 200) {
            response.json().then(responseJson => {                
                dispatch(fetchChatMessagesDone(responseJson)) 
            })
        } else {
            dispatch(fetchChatMessagesDone([])) 
        }
    }).catch(() => {
        toast.error('🚫 Something went wrong with fetching messages, Please try again.',{autoClose:3000,position:'top-center'})
        dispatch(fetchChatMessagesDone([])) 
    })
}

export const onFetchChatUserInformation = (referenceId, referenceType) => dispatch => {
    return client.fetchChatUserInformation(referenceId, referenceType).then(response => {
        if(response.status === 200) {
            response.json().then(responseJson => {                                                
                dispatch(fetchChatUserInformationDone(responseJson))
            })
        } else {
            toast.error('🚫 Something went wrong with fetching sender information, Please try again.',{autoClose:3000,position:'top-center'})
            dispatch(fetchChatUserInformationDone({})) 
        }
    }).catch(() => {
        toast.error('🚫 Something went wrong with fetching sender information, Please try again.',{autoClose:3000,position:'top-center'})
        dispatch(fetchChatUserInformationDone({})) 
    })
}
export const onSendMessage = (data, isNew, userId, roleName, searchString) => dispatch => {
    dispatch(startInboxLoader())
    return client.postMessage(data).then(response => {
        if(response.status === 200 || response.ok){
            response.json().then(responsejson => {
                if(responsejson.statusCode === 200) {
                    dispatch(stopInboxLoader());
                    if(responsejson.messages && responsejson.messages.id) {
                        dispatch(onSaveSendMessageToChatList(responsejson.messages))
                        dispatch(onSaveMessageInLocalList(responsejson.messages))
                    }

                    let state = store.getState();
                    let inboxList = state.inbox?.inboxList || [];                    
                    const referenceId = inboxList && inboxList.length > 0 ? inboxList[0].referenceId : "";
                    const messageReferenceId = responsejson.messages && responsejson.messages.referenceId ? responsejson.messages.referenceId : "";
                    
                    if(isNew || referenceId !== messageReferenceId) {
                        dispatch(fetchInboxList(userId, roleName, searchString));
                    }
                } else {
                    dispatch(stopInboxLoader());
                    toast.error('🚫 Message sending failed.',{autoClose:3000,position:'top-center'})
                }
            })
        } else {
            toast.error('🚫 Something went wrong with sending message, Please try again.',{autoClose:3000,position:'top-center'})
            dispatch(stopInboxLoader())
        }
    }).catch(() => {
        toast.error('🚫 Something went wrong with sending message, Please try again.',{autoClose:3000,position:'top-center'})
        dispatch(stopInboxLoader())
    })
}

export const onFetchInboxAnnouncementsByProperty = (userId, roleName, propertyId) => dispatch => {
    dispatch(startInboxLoader())
    return client.fetchInboxAnnouncementsByProperty(userId, roleName, propertyId).then(response => {
        if(response.status === 200) {
            response.json().then(responseJson => {                       
               dispatch(fetchInboxAnnouncementsByPropertyDone(responseJson))      
            })
        } else {
            dispatch(fetchInboxAnnouncementsByPropertyDone([])) 
        }
    }).catch(() => {
        dispatch(fetchInboxAnnouncementsByPropertyDone([])) 
    })
}
/* 
    Created By: Sai Prasad
    Created Date: 14/09/2022
    Jira Ticket: JUN-3083
    Description: function to update unread messages to read
*/

export const onUpdateUnreadToReadMessages = (referenceId, referenceType, userId) => dispatch => {
    return client.updateUnreadToReadMessages(referenceId, referenceType, userId).then(response => {
        if(response.status === 200) {
            response.json().then(responseJson => {
                if(responseJson.statusCode === 200) {
                    dispatch(onUpdateMessageToUnreadToReadDone({referenceId: referenceId}))
                }
            })
        }
    })
}
export const onClearInboxList = () => dispatch => {
    dispatch({
        type: TYPES.CLEAR_INBOX_LIST_DONE
    })
}
export const onClearChatMessages = () => dispatch => {
    dispatch({
        type: TYPES.CLEAR_INBOX_CHAT_MESSAGES_DONE
    })
}
export const onClearInboxAnnouncementsByProperty = () => dispatch => {
    dispatch({
        type: TYPES.CLEAR_INBOX_ANNOUNCEMENTS_BY_PROPERTY
    })
}
export const onSetAnnouncement = (payload) => dispatch => {
    dispatch({
        type: TYPES.SET_ANNOUNCEMENT,
        payload: payload
    })
}
export const onSaveInboxItem = (payload) => dispatch => {
    dispatch({
        type: TYPES.SAVE_INBOX_ITEM,
        payload: payload
    })
}
export const onClearChatUserInformationDone = () => dispatch => {
    dispatch({
        type: TYPES.CLEAR_CHAT_USER_INFORMATION_DONE
    })
}
export const onSaveSelectedItem = (payload) => dispatch => {
    dispatch({
        type: TYPES.SAVE_SELECTED_ITEM_DONE,
        payload: payload
    })
}
export const onUpdateMessageToUnreadToReadDone = (payload) => dispatch => {
    dispatch({
        type: TYPES.UPDATE_MESSAGE_TO_INREAD_TO_READ,
        payload: payload
    })
}